module.exports = __webpack_public_path__ + "img/fb5c5c9.jpg";